/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Dropdown, Image, TableColumnsType, Tag } from "antd";
import TableUi from "../../../../../../atoms/Table";
import { useRef, useState } from "react";
import { PopUp } from "../../../../../../atoms/PopUp";
import EmptyCard from "../../../../../../atoms/EmptyCard";
import { CrossIcon, DeleteIcon } from "../../../../../../atoms/CustomIcons";
import ConfirmDelete from "../../../../../../atoms/ConfirmDelete";
import { useNavigate } from "react-router-dom";
import { MoreOutlined } from "@ant-design/icons";
import Filters from "./Components/Filters";
import taskTable from "../../DummyData/taskTable.json";
import TaskModal from "./Components/TaskModal";

export default function Tasks() {
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const navigate = useNavigate();
  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [tableRecord, setTableRecord] = useState<any | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [archivePopUp, setArchivePopUp] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [archived, isArchived] = useState(false);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/edit-crews/tableRecord/${companyId}`);
          }}
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
        >
          Edit details
        </Button>
      ),
    },
    // {
    //   key: "2",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         tableRecord?.status === "active"
    //           ? setArchivePopUp(true)
    //           : archiveFunction();
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //       }}
    //       icon={
    //         <Image
    //           src={`/images/table/${
    //             tableRecord?.status === "active" ? "archive" : "activate"
    //           }-icon.svg`}
    //           preview={false}
    //         />
    //       }
    //     >
    //       {tableRecord?.status === "active" ? "Archive" : "Activate"}
    //     </Button>
    //   ),
    // },
    {
      key: "3",
      label: (
        <Button
          type="text"
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          className="delete-hover"
          icon={<DeleteIcon />}
        >
          Delete
        </Button>
      ),
    },
  ];

  const statusClassMap: Record<string, string> = {
    open: "grey_tag",
    completed: "accepted_tag",
    scheduled: "approval_pending_tag",
    closed: "cancelled_tag",
  };

  const serviceLineClassMap: Record<string, string> = {
    "landscape maintenance": "green_tag",
    "lawn care": "orange_tag",
    irrigation: "violet_tag",
    construction: "yellow_tag",
  };

  const columns: TableColumnsType = [
    {
      title: "Tasks",
      dataIndex: "name",
      width: 320,
      render: (text) => text ?? "-",
      fixed: "left",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 147,
      render: (text) => {
        const cls = statusClassMap[text?.toLowerCase()] || "default_tag";
        return (
          <Tag
            className={cls}
            style={{ textTransform: "capitalize", border: 0 }}
          >
            {text}
          </Tag>
        );
      },
    },
    {
      title: "Contract",
      dataIndex: "contract",
      width: 270,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.contract - b?.contract,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: 140,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Due date",
      dataIndex: "due_date",
      width: 170,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Occurrences",
      dataIndex: "occurrence",
      width: 140,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Scheduled date",
      dataIndex: "schedule_date",
      width: 195,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Service line",
      dataIndex: "service_line",
      width: 270,
      render: (text) => {
        const cls = serviceLineClassMap[text?.toLowerCase()] || "default_tag";
        return (
          <Tag
            className={cls}
            style={{ textTransform: "capitalize", border: 0 }}
          >
            {text}
          </Tag>
        );
      },
      sorter: (a, b) => a?.service_line?.localeCompare(b?.service_line),
    },
    {
      title: "Service",
      dataIndex: "service",
      width: 270,
      render: (text) => (text ? text : "-"),
    },

    {
      title: "Date completed",
      dataIndex: "date_completed",
      width: 170,
      render: (text) => text ?? "-",
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{
            items:
              record?.status === "active"
                ? items
                : items.filter(
                    (item) => item?.key !== "1" && item?.key !== "1"
                  ),
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              // setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  const deleteFunction = () => {
    setLoading(true);
  };

  const deleteClientPopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          selectedRowKeys?.length > 0 ? (
            <>
              Are you sure you want to delete selected crews?
              <br />
              This action cannot be undone.
            </>
          ) : (
            <>
              Are you sure you want to delete <b>tableRecord?.name</b>?<br />
              <br />
              This action cannot be undone.
            </>
          )
        }
        btnText={
          selectedRowKeys?.length > 0
            ? `Delete ${
                selectedRowKeys?.length === 1
                  ? selectedRowKeys?.length + " crew"
                  : selectedRowKeys?.length + " crews"
              }`
            : "Delete crew"
        }
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const taskDetailModal = {
    visibility: isTaskModalOpen,
    class: "Task_Modal",
    content: (
      <TaskModal
        onClose={() => setIsTaskModalOpen(false)}
        tableRecord={tableRecord}
        loading={loading}
      />
    ),
    width: 1200,
    onCancel: () => setIsTaskModalOpen(false),
  };

  const archiveFunction = () => {
    setLoading(true);
  };

  const confirmArchivedPopUp = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading='{tableRecord?.status === "active" ? "Archive" : "Activate"}'
        paragraph={
          <>
            Are you sure you want to{" "}
            {/* {tableRecord?.status === "active" ? "archive" : "activate"}{" "}
            <b>{tableRecord?.name}</b>? <br /> <br />
            {tableRecord?.status === "active" && (
              <>This crew won’t be available for use.</>
            )} */}
          </>
        }
        btnText={`${
          "Activate"
          // tableRecord?.status === "active" ? "Archive" : "Activate"
        } crew`}
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  const onClickRow = (record: any) => {
    return {
      onClick: () => {
        setTableRecord(record);
        setIsTaskModalOpen(true);
      },
    };
  };

  return (
    <div className="profileTableWrapper">
      <Card className="profileTableCard">
        <TableUi
          columns={columns}
          data={{
            count: taskTable?.length,
            data: taskTable || [],
          }}
          filters={
            <Filters
              setFilters={setFilters}
              filters={filters}
              archived={archived}
              isArchived={isArchived}
              companyId={companyId}
            />
          }
          pageSize={limit}
          setPageSize={setLimit}
          setCurrentPage={setPagination}
          currentPage={pagination}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          createButtonText="New task"
          createButtonLink={`/new-task/${companyId}`}
          onClickRow={onClickRow}
        />
        {taskTable?.length === 0 && (
          <div className="empty_wrap">
            <EmptyCard
              imageHeight={220}
              title={
                archived
                  ? "There are no archived crews"
                  : filters?.search_text
                  ? "No results match the filter or search criteria"
                  : `There are no ${filters?.status ?? "active"} crews`
              }
              description={
                archived
                  ? "We believe in our absolute success and hope to never have an archived crews here."
                  : filters?.search_text
                  ? "Try adjusting the filters and search."
                  : ""
              }
              image={
                archived
                  ? "/images/empty-icons/no-archived.svg"
                  : "/images/empty-icons/no-active.svg"
              }
            />
          </div>
        )}

        {selectedRowKeys?.length !== 0 ? (
          <div className="selection_bar">
            <div className="selected_count">
              <Button
                icon={<CrossIcon style={{ color: "white" }} />}
                className="only_icon"
                type="text"
                onClick={() => setSelectedRowKeys([])}
              />
              {selectedRowKeys.length}{" "}
              {`${selectedRowKeys.length === 1 ? "crew" : "crews"}`} selected
            </div>
            <div className="selection_buttons">
              <Button
                type="text"
                icon={<DeleteIcon />}
                onClick={() => {
                  setIsDeleteModalOpen(true);
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        ) : null}

        <PopUp {...deleteClientPopUp} />
        <PopUp {...confirmArchivedPopUp} />
        <PopUp {...taskDetailModal} />
      </Card>
    </div>
  );
}
